<template>
    <div>
        <splitpanes id="page-wrap" class="default-theme">
            <pane min-size="25" size="65">
                <inspiration-view :content="content" />
            </pane>
            <pane min-size="25" max-size="75">
                <inspiration-form
                    :title="content.title"
                    :content="content"
                    @updateTitle="content.title = $event"
                    @updateProjectTypes="content.projectType = $event"
                    @updateCompetences="content.keyCompetences = $event"
                    @updateSubjects="content.subjects = $event"
                    @updateProject="content.project = $event"
                    @updateDuration="content.duration = $event"
                    @updateLevel="content.level = $event"
                    @updateShortDescription="content.shortDescription = $event"
                />
            </pane>
        </splitpanes>
    </div>
</template>

<script>
import InspirationView from '@/components/InspirationView';
import InspirationForm from '@/components/InspirationForm';
import { Splitpanes, Pane } from 'splitpanes';
import _ from 'underscore';
export default {
    components: {
        Splitpanes,
        Pane,
        InspirationView,
        InspirationForm,
    },
    data() {
        return {
            content: {
                /*featuredImage:"",
                title:"",
                introduction:"",
                projectType:[],
                softSkills:[],
                keyCompetences:[],
                subjects:[],
                learningObjectives:"",
                activities:[],
                projects:[]*/
                image: {},
                title: '',
                introduction: '',
                projectType: [],
                softSkills: '',
                keyCompetences: [],
                subjects: [],
                learningObjectives: '',
                activities: [],
                project: '',
                duration: '',
                level: '',
                shortDescription: '',
            },
        };
    },
    computed: {},
    watch: {},
    mounted() {},
    methods: {},
};
</script>

<style scoped lang="css">
@import '~splitpanes/dist/splitpanes.css';
html {
    overflow: auto;
}
.splitpanes__pane {
    background-color: transparent !important;
}
</style>
